import React, { useEffect, useState } from "react";
import styled from "styled-components";

import { useParams } from "react-router-dom";
import downloadIcon from "../img/download.svg";
import shareIcon from "../img/share.svg";

import { isIOS } from "react-device-detect";
import { getFilesByPath } from "../services/nextcloud";

const checkDate = (date) => {
  let currentDate = new Date().toISOString().substring(0, 10);

  if (date >= currentDate) return true;

  return false;
};
const MainContainer = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  height: 100vh;
  width: 100vw;
`;
const IconsContainer = styled.div`
  position: relative;
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row;
  order: 2;
`;
const IconsBox = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 10vh;
`;
const IconDownloadBox = styled.a``;
const IconShareBox = styled.a``;
const Icon = styled.img`
  width: ${({ width }) => width}px;
  height: ${({ height }) => height}px;
  padding: 0 10px;
  opacity: 0.5;
  &:active,
  &:focus {
    cursor: pointer;
    opacity: 1;
  }
  @media (min-width: 768px) {
    width: 70px;
    height: 70px;
  }
`;
const Video = styled.video`
  width: 100%;
  height: 100%;
`;
const Source = styled.source``;

const realWidth = window.innerWidth;

const size = [
  {
    id: 0,
    width: 1080,
    responsiveWidth: "70%",
  },

  {
    id: 1,
    width: 1920,
    responsiveWidth: "60%",
  },

  {
    id: 2,
    width: 2560,
    responsiveWidth: "60%",
  },

  {
    id: 3,
    width: 1024,
    responsiveWidth: "60%",
  },

  {
    id: 4,
    width: 1366,
    responsiveWidth: "60%",
  },

  {
    id: 5,
    width: 1536,
    responsiveWidth: "60%",
  },
];

let valwidth;
let respwidth;

size.forEach((value, index) => {
  if (realWidth === value.width) {
    respwidth = value.responsiveWidth;
    valwidth = value.width;
  }
});

const ImageBox = styled.div`
  width: auto;
  height: ${realWidth === valwidth || realWidth >= valwidth
    ? respwidth
    : "65%"};
`;
const Image = styled.img`
  width: auto;
  height: 100%;
`;

export const Home = () => {
  let { base64 } = useParams();
  const [files, setFiles] = useState();
  const [base64Data, setBase64Data] = useState();

  useEffect(() => {
    if (base64) {
      localStorage.setItem("base64Data", base64);
      setBase64Data(base64);
    } else {
      if (localStorage.getItem("base64Data")) {
        setBase64Data(localStorage.getItem("base64Data"));
      }
    }
  }, []);

  useEffect(() => {
    if (base64Data) {
      const dataObject = JSON.parse(atob(decodeURIComponent(base64Data)));

      const dateIsValid = checkDate(dataObject.expiration);

      const saneUrl = decodeURI(dataObject.url);

      //window.history.replaceState(null, null, "/");
      if (dateIsValid) {
        const getFiles = async () => {
          const handleFiles = await getFilesByPath(saneUrl);
          setFiles(handleFiles);
        };
        getFiles();
      }
    }
  }, [base64Data]);

  useEffect(() => {
    if (files && files.length > 0) {
      const shareData = {
        files: [files[0].binary],
      };

      const btn = document.querySelector("#share-button");

      if (navigator.canShare && navigator.canShare(shareData)) {
        // Deve ser acionado algum tipo de "ativação do usuário"
        btn.addEventListener("click", async () => {
          navigator.share(shareData);
        });
      }
    }
  }, [files]);

  if (files && files.length > 0) {
    return (
      <MainContainer>
        <IconsContainer>
          <IconsBox>
            <IconDownloadBox
              href={files[0].src}
              target={isIOS ? "_blank" : "_self"}
              download={files[0].type === "video" ? `video.mp4` : `image.jpeg`}
            >
              <Icon src={downloadIcon} width={45} height={45} />
            </IconDownloadBox>
            {navigator.canShare ? (
              <IconShareBox id="share-button">
                <Icon src={shareIcon} width={27} height={27} />
              </IconShareBox>
            ) : null}
          </IconsBox>
        </IconsContainer>

        <ImageBox>
          {files[0].type === "video" ? (
            <Video controls={false} autoPlay loop muted>
              <Source src={files[0].src} />
            </Video>
          ) : (
            <Image src={files[0].src} />
          )}
        </ImageBox>
      </MainContainer>
    );
  } else {
    return <></>;
  }
};
